import { useState } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

export default function ContactPage() {
  const [appointmentSubmitted, setAppointmentSubmitted] = useState(false);

  const handleAppointmentSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const name = formData.get('name') as string;
    const email = formData.get('email') as string;
    const phone = formData.get('phone') as string;
    const date = formData.get('date') as string;
    const time = formData.get('time') as string;

    if (!name || !email || !phone || !date || !time) return;

    const submitBtn = form.querySelector('button[type="submit"]') as HTMLButtonElement;
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Gönderiliyor...';
    }

    try {
      const response = await fetch('https://readdy.ai/api/form/d65dc1vn41fpv0tki24g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as any).toString(),
      });
      if (response.ok) {
        setAppointmentSubmitted(true);
        form.reset();
      }
    } catch {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Randevu Talep Et';
      }
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero */}
      <section className="relative bg-[#1a1a1a] text-white py-24">
        <div className="absolute inset-0">
          <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#DD0000]/10 rounded-full blur-[120px]"></div>
          <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-[#FFCE00]/8 rounded-full blur-[100px]"></div>
        </div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">İletişim</h1>
            <p className="text-xl text-gray-300">
              Almanya&apos;da eğitim hayaliniz için bize ulaşın. Size yardımcı olmaktan mutluluk duyarız.
            </p>
          </div>
        </div>
      </section>

      {/* İletişim Bilgileri */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto mb-16">
            {/* Türkiye Adres */}
            <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-all">
              <div className="w-14 h-14 bg-[#FFCE00] rounded-xl flex items-center justify-center mb-4">
                <i className="ri-building-2-line text-2xl text-[#1a1a1a]"></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2">Türkiye Ofis</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                Esentepe M. Mithat Ulu Ünlü S.<br />
                No: 26/26 Şişli<br />
                İstanbul
              </p>
            </div>

            {/* Telefon */}
            <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-all">
              <div className="w-14 h-14 bg-[#1a1a1a] rounded-xl flex items-center justify-center mb-4">
                <i className="ri-phone-line text-2xl text-white"></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2">Telefon</h3>
              <a href="tel:+902129126797" className="text-sm text-gray-600 hover:text-[#DD0000] transition-colors block cursor-pointer">
                0212 912 67 97 (Ofis)
              </a>
            </div>

            {/* E-posta */}
            <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-all">
              <div className="w-14 h-14 bg-[#DD0000] rounded-xl flex items-center justify-center mb-4">
                <i className="ri-mail-line text-2xl text-white"></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2">E-posta</h3>
              <a href="mailto:rotaberlinn@gmail.com" className="text-sm text-[#DD0000] hover:text-[#bb0000] transition-colors block cursor-pointer font-medium">
                rotaberlinn@gmail.com
              </a>
            </div>
          </div>

          {/* Randevu Formu */}
          <div className="max-w-2xl mx-auto">
            <div className="text-center mb-8">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#FFCE00]/10 border border-[#FFCE00]/20 rounded-full mb-4">
                <i className="ri-calendar-check-line text-[#DD0000]"></i>
                <span className="text-[#1a1a1a] text-sm font-medium">Ücretsiz Danışmanlık</span>
              </div>
              <h2 className="text-3xl font-bold text-gray-900 mb-2">Randevu Alın</h2>
              <p className="text-gray-600">Ücretsiz danışmanlık randevusu için formu doldurun.</p>
            </div>

            {appointmentSubmitted ? (
              <div className="bg-green-50 border border-green-200 rounded-xl p-8 text-center">
                <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-check-line text-3xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Randevunuz Alındı!</h3>
                <p className="text-gray-600">En kısa sürede sizinle iletişime geçeceğiz.</p>
              </div>
            ) : (
              <form
                id="contact-appointment-form"
                data-readdy-form
                onSubmit={handleAppointmentSubmit}
                className="bg-white border border-gray-200 rounded-xl p-8 shadow-lg space-y-5"
              >
                <div className="grid md:grid-cols-2 gap-5">
                  <div>
                    <label htmlFor="apt-name" className="block text-sm font-semibold text-gray-700 mb-1.5">Ad Soyad *</label>
                    <input type="text" id="apt-name" name="name" required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#DD0000] focus:border-transparent text-sm" placeholder="Adınız ve soyadınız" />
                  </div>
                  <div>
                    <label htmlFor="apt-email" className="block text-sm font-semibold text-gray-700 mb-1.5">E-posta *</label>
                    <input type="email" id="apt-email" name="email" required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#DD0000] focus:border-transparent text-sm" placeholder="ornek@email.com" />
                  </div>
                </div>
                <div className="grid md:grid-cols-2 gap-5">
                  <div>
                    <label htmlFor="apt-phone" className="block text-sm font-semibold text-gray-700 mb-1.5">Telefon *</label>
                    <input type="tel" id="apt-phone" name="phone" required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#DD0000] focus:border-transparent text-sm" placeholder="+90 5XX XXX XX XX" />
                  </div>
                  <div>
                    <label htmlFor="apt-service" className="block text-sm font-semibold text-gray-700 mb-1.5">Hizmet</label>
                    <select id="apt-service" name="service" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#DD0000] focus:border-transparent text-sm">
                      <option value="Genel Danışmanlık">Genel Danışmanlık</option>
                      <option value="Lisans Programları">Lisans Programları</option>
                      <option value="Yüksek Lisans">Yüksek Lisans</option>
                      <option value="Dil Okulu">Dil Okulu</option>
                      <option value="Vize İşlemleri">Vize İşlemleri</option>
                      <option value="Bloke Hesap">Bloke Hesap</option>
                      <option value="Sağlık Sigortası">Sağlık Sigortası</option>
                      <option value="Konaklama">Konaklama</option>
                      <option value="Havalimanı Karşılama">Havalimanı Karşılama</option>
                    </select>
                  </div>
                </div>
                <div className="grid md:grid-cols-2 gap-5">
                  <div>
                    <label htmlFor="apt-date" className="block text-sm font-semibold text-gray-700 mb-1.5">Tarih *</label>
                    <input type="date" id="apt-date" name="date" required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#DD0000] focus:border-transparent text-sm" />
                  </div>
                  <div>
                    <label htmlFor="apt-time" className="block text-sm font-semibold text-gray-700 mb-1.5">Saat *</label>
                    <select id="apt-time" name="time" required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#DD0000] focus:border-transparent text-sm">
                      <option value="">Saat seçin</option>
                      <option value="09:00">09:00</option>
                      <option value="10:00">10:00</option>
                      <option value="11:00">11:00</option>
                      <option value="12:00">12:00</option>
                      <option value="14:00">14:00</option>
                      <option value="15:00">15:00</option>
                      <option value="16:00">16:00</option>
                      <option value="17:00">17:00</option>
                    </select>
                  </div>
                </div>
                <button type="submit" className="w-full px-8 py-4 bg-[#DD0000] text-white font-bold text-lg rounded-lg hover:bg-[#bb0000] transition-all whitespace-nowrap cursor-pointer">
                  Randevu Talep Et
                </button>
              </form>
            )}
          </div>
        </div>
      </section>

      {/* Harita */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Ofisimizi Ziyaret Edin</h2>
          </div>
          <div className="max-w-4xl mx-auto">
            <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
              <i className="ri-map-pin-line text-[#FFCE00]"></i>
              Türkiye - İstanbul
            </h3>
            <div className="rounded-xl overflow-hidden shadow-lg">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3008.2!2d29.0108!3d41.0628!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab7a2a2a2a2a2%3A0x0!2sEsentepe%20Mah.%20Mithat%20Ulu%20%C3%9Cnl%C3%BC%20Sk.%20No%3A26%2F26%2C%20%C5%9Ei%C5%9Fli%2C%20%C4%B0stanbul!5e0!3m2!1str!2str!4v1234567892"
                width="100%"
                height="400"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Rota Berlin Türkiye Ofis - Esentepe M. Mithat Ulu Ünlü S. No: 26/26 Şişli İstanbul"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-[#1a1a1a] text-white">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Hemen İletişime Geçin</h2>
          <p className="text-gray-300 mb-8 max-w-2xl mx-auto">
            Almanya&apos;da eğitim hayalinizi gerçekleştirmek için ilk adımı atın.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a href="mailto:rotaberlinn@gmail.com" className="px-8 py-4 bg-[#DD0000] text-white font-semibold rounded-lg hover:bg-[#bb0000] transition-all whitespace-nowrap cursor-pointer flex items-center gap-2">
              <i className="ri-mail-line text-2xl"></i>
              E-posta Gönder
            </a>
            <a href="tel:+902129126797" className="px-8 py-4 bg-[#FFCE00] text-[#1a1a1a] font-semibold rounded-lg hover:bg-[#e6b800] transition-all whitespace-nowrap cursor-pointer flex items-center gap-2">
              <i className="ri-phone-line text-2xl"></i>
              Hemen Arayın
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
